import { useTranslation } from 'react-i18next';
import { Calendar, MapPin, Clock } from 'lucide-react';

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  
  // Font selection based on language
  const getTitleFont = () => {
    if (i18n.language === 'el') {
      return 'Crimson Text, Cormorant Garamond, serif'; // Elegant thin fonts for Greek
    }
    return 'Crimson Text, Cormorant Garamond, serif'; // Elegant thin fonts for other languages
  };

  const getTextFont = () => {
    if (i18n.language === 'el') {
      return 'Crimson Text, Cormorant Garamond, serif';
    }
    return 'Crimson Text, Cormorant Garamond, serif';
  };

  // Background image selection based on language
  const getDesktopBackgroundImage = () => {
    switch (i18n.language) {
      case 'el':
        return "url('/images/vasirod_gre.png')"; // Greek version
      case 'de':
        return "url('/images/vasirod_ger.png')"; // German version
      case 'en':
      default:
        return "url('/images/vasirod_eng.png')"; // English/default version
    }
  };

  // Mobile background image selection based on language
  const getMobileBackgroundImage = () => {
    switch (i18n.language) {
      case 'el':
        return "url('/images/vasirod_mobile_gre.png')"; // Greek mobile version
      case 'de':
        return "url('/images/vasirod_mobile_ger.png')"; // German mobile version
      case 'en':
      default:
        return "url('/images/vasirod_mobile_eng.png')"; // English mobile version
    }
  };

  return (
    <section className="relative min-h-screen md:min-h-screen w-full flex flex-col justify-end bg-cover bg-center bg-no-repeat text-amber-50 overflow-hidden" style={{ minHeight: window.innerWidth < 768 ? '130vh' : '100vh' }}>
      {/* Desktop background */}
      <div 
        className="absolute inset-0 hidden md:block w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: getDesktopBackgroundImage(),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      ></div>
      
      {/* Mobile background */}
      <div 
        className="absolute inset-0 block md:hidden w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: getMobileBackgroundImage(),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      ></div>

      {/* Mobile-only RSVP button */}
      <div className="block md:hidden relative z-20 text-center pb-16 px-4" style={{ paddingTop: '65vh' }}>
        <a
          href="#rsvp"
          className="inline-block bg-white text-black font-bold py-4 px-8 rounded-full hover:bg-opacity-90 transform hover:scale-105 transition-all duration-200 shadow-xl hover:shadow-2xl"
        >
          {t('rsvpNow')} →
        </a>
        <div className="mt-6 mx-auto max-w-md">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 shadow-lg">
            <p className="text-xs text-gray-700 leading-relaxed">
              {t('rsvpDeadlineDisclaimer')}
            </p>
          </div>
        </div>
      </div>

      {/* Desktop-only RSVP button */}
      <div className="hidden md:block relative z-20 text-center pb-16" style={{ paddingTop: '700px' }}>
        <a
          href="#rsvp"
          className="inline-block bg-white text-black font-bold py-4 px-8 rounded-full hover:bg-opacity-90 transform hover:scale-105 transition-all duration-200 shadow-xl hover:shadow-2xl"
        >
          {t('rsvpNow')} →
        </a>
        <div className="mt-6 mx-auto max-w-lg">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-5 shadow-lg">
            <p className="text-sm text-gray-700 leading-relaxed">
              {t('rsvpDeadlineDisclaimer')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;